import GridSettings from './grid-configuracao';

export default GridSettings